import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {MandantenAuswahlPageRoutingModule} from './mandanten-auswahl-routing.module';
import {MandantenAuswahlPage} from './mandanten-auswahl.page';
import {StoreModule} from '@ngrx/store';
import {MandantAuwahlFeature, reducers} from './mandanten-auswahl.reducer';
import {ApiMeineMandantenEffects} from '../../../client-ngrx/api';
import {EffectsModule} from '@ngrx/effects';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';
import {PipesModule} from '../../../sopi/pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        StoreModule.forFeature(MandantAuwahlFeature, reducers),

        EffectsModule.forFeature([
            ApiMeineMandantenEffects,
        ]),
        MandantenAuswahlPageRoutingModule,
        SopiScrollModule,
        SopiComponentsModule.forRoot(),
        PipesModule
    ],
    declarations: [MandantenAuswahlPage]
})
export class MandantenAuswahlPageModule {
}
